import React from "react";
import { Typography, Container } from "@mui/material";

import StyledNotFound from "./styles";

const NotFoundMessage = ({ Icon, message, iconSize = 60 }) => {
  return (
    <Container maxWidth="xs">
      <StyledNotFound>
        <div className="not-found-message">
          {Icon && <Icon sx={{ width: iconSize, height: iconSize }} />}
          {message && <Typography variant="h6">{message}</Typography>}
        </div>
      </StyledNotFound>
    </Container>
  );
};

export default NotFoundMessage;
